module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-131.b2a1ed23.jpg";